module.exports = __webpack_public_path__ + "static/media/InfraWorks Application Home.9cb10602.png";